module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-2b53f02f.png";